// Attendance Reports
export const FETCH_ATTENDANCE_CONSOLIDATED_REPORT_REQUEST = "FETCH_ATTENDANCE_CONSOLIDATED_REPORT_REQUEST";
export const FETCH_ATTENDANCE_CONSOLIDATED_REPORT_SUCCESS = "FETCH_ATTENDANCE_CONSOLIDATED_REPORT_SUCCESS";
export const FETCH_ATTENDANCE_CONSOLIDATED_REPORT_FAILURE = "FETCH_ATTENDANCE_CONSOLIDATED_REPORT_FAILURE";

export const FETCH_DAY_WISE_ATTENDANCE_REPORT_REQUEST = "FETCH_DAY_WISE_ATTENDANCE_REPORT_REQUEST";
export const FETCH_DAY_WISE_ATTENDANCE_REPORT_SUCCESS = "FETCH_DAY_WISE_ATTENDANCE_REPORT_SUCCESS";
export const FETCH_DAY_WISE_ATTENDANCE_REPORT_FAILURE = "FETCH_DAY_WISE_ATTENDANCE_REPORT_FAILURE";

export const FETCH_LATE_ATTENDANCE_REPORT_REQUEST = "FETCH_LATE_ATTENDANCE_REPORT_REQUEST";
export const FETCH_LATE_ATTENDANCE_REPORT_SUCCESS = "FETCH_LATE_ATTENDANCE_REPORT_SUCCESS";
export const FETCH_LATE_ATTENDANCE_REPORT_FAILURE = "FETCH_LATE_ATTENDANCE_REPORT_FAILURE";

export const FETCH_ABSENTEEISM_REPORT_REQUEST = "FETCH_ABSENTEEISM_REPORT_REQUEST";
export const FETCH_ABSENTEEISM_REPORT_SUCCESS = "FETCH_ABSENTEEISM_REPORT_SUCCESS";
export const FETCH_ABSENTEEISM_REPORT_FAILURE = "FETCH_ABSENTEEISM_REPORT_FAILURE";

export const FETCH_EXTRA_HOURS_REPORT_REQUEST = "FETCH_EXTRA_HOURS_REPORT_REQUEST";
export const FETCH_EXTRA_HOURS_REPORT_SUCCESS = "FETCH_EXTRA_HOURS_REPORT_SUCCESS";
export const FETCH_EXTRA_HOURS_REPORT_FAILURE = "FETCH_EXTRA_HOURS_REPORT_FAILURE";

export const GET_MOBILE_PUNCH_REPORT_REQUEST = "GET_MOBILE_PUNCH_REPORT_REQUEST";
export const GET_MOBILE_PUNCH_REPORT_SUCCESS = "GET_MOBILE_PUNCH_REPORT_SUCCESS";
export const GET_MOBILE_PUNCH_REPORT_FAILURE = "GET_MOBILE_PUNCH_REPORT_FAILURE";

export const FETCH_LEAVE_REPORT_REQUEST = "FETCH_LEAVE_REPORT_REQUEST";
export const FETCH_LEAVE_REPORT_SUCCESS = "FETCH_LEAVE_REPORT_SUCCESS";
export const FETCH_LEAVE_REPORT_FAILURE = "FETCH_LEAVE_REPORT_FAILURE";

export const FETCH_SHIFT_REPORT_REQUEST = "FETCH_SHIFT_REPORT_REQUEST";
export const FETCH_SHIFT_REPORT_SUCCESS = "FETCH_SHIFT_REPORT_SUCCESS";
export const FETCH_SHIFT_REPORT_FAILURE = "FETCH_SHIFT_REPORT_FAILURE";

export const FETCH_SHIFT_DETAILS_REPORT_REQUEST = "FETCH_SHIFT_DETAILS_REPORT_REQUEST";
export const FETCH_SHIFT_DETAILS_REPORT_SUCCESS = "FETCH_SHIFT_DETAILS_REPORT_SUCCESS";
export const FETCH_SHIFT_DETAILS_REPORT_FAILURE = "FETCH_SHIFT_DETAILS_REPORT_FAILURE";

export const FETCH_SHIFT_LOG_REPORT_REQUEST = "FETCH_SHIFT_LOG_REPORT_REQUEST";
export const FETCH_SHIFT_LOG_REPORT_SUCCESS = "FETCH_SHIFT_LOG_REPORT_SUCCESS";
export const FETCH_SHIFT_LOG_REPORT_FAILURE = "FETCH_SHIFT_LOG_REPORT_FAILURE";

export const FETCH_LEAVE_BALANCE_REPORT_REQUEST = "FETCH_LEAVE_BALANCE_REPORT_REQUEST";
export const FETCH_LEAVE_BALANCE_REPORT_SUCCESS = "FETCH_LEAVE_BALANCE_REPORT_SUCCESS";
export const  FETCH_LEAVE_BALANCE_REPORT_FAILURE = "FETCH_LEAVE_BALANCE_REPORT_FAILURE";

export const FETCH_FORM6_REPORT_REQUEST = "FETCH_FORM6_REPORT_REQUEST";
export const FETCH_FORM6_REPORT_SUCCESS = "FETCH_FORM6_REPORT_SUCCESS";
export const FETCH_FORM6_REPORT_FAILURE = "FETCH_FORM6_REPORT_FAILURE";

export const FETCH_FORM34_REPORT_REQUEST = "FETCH_FORM34_REPORT_REQUEST";
export const FETCH_FORM34_REPORT_SUCCESS = "FETCH_FORM34_REPORT_SUCCESS";
export const FETCH_FORM34_REPORT_FAILURE = "FETCH_FORM34_REPORT_FAILURE";

export const FETCH_BREAKIN_REPORT_REQUEST = "FETCH_BREAKIN_REPORT_REQUEST";
export const FETCH_BREAKIN_REPORT_SUCCESS = "FETCH_BREAKIN_REPORT_SUCCESS";
export const FETCH_BREAKIN_REPORT_FAILURE = "FETCH_BREAKIN_REPORT_FAILURE";

export const RESET_ATTENDANCE_REPORT= "RESET_ATTENDANCE_REPORT";